import { render, staticRenderFns } from "./result-image.vue?vue&type=template&id=84c07e22&"
import script from "./result-image.vue?vue&type=script&lang=ts&"
export * from "./result-image.vue?vue&type=script&lang=ts&"
import style0 from "./result-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports